var $ = require('../modules/jquery');
var fitvids = require('../modules/jquery.fitvids');

$(function() {
    // initialize embedded videos
    $('iframe[src*="youtube"]').parent().fitVids();
});



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/videos.js
// module id = 52
// module chunks = 2